import dayjs from 'dayjs'

export const getTrialPlanDayTillExpired = (expiresAt: string): number => {
  const format = 'YYYY-MM-DD';
  const currentDate = dayjs(dayjs(), format).format(format);
  const expiresAtDate = dayjs(dayjs(expiresAt), format).format(format);

  return dayjs(expiresAtDate, format).diff(currentDate, 'days');
}